<template>
	<!-- 日期插件 -->
	<div class="rqbox" :style="{'background':bgColor}">
		<div class="title">
			<span class="titlename">{{title}}</span>
			<span class="titletips">
				共<span style="padding: 0 5px;">{{selectDay}}</span>晚
			</span>
			<span class="titletips">
				点击下方日期选择入住日期
			</span>
		</div>
		<div class="rqlist">
			<van-swipe :loop="false" :width="85" :height="60" :show-indicators="false">
				<van-swipe-item @click="show=true" v-for="(item,index) in dateList" :key="index"
					style="margin-right: 5px;" class="riitem riitem-active">
					<div class="itemname">
						<span>{{item.dd.week}}</span>
						<span>{{item.dd.dd}}</span>
					</div>
					<div class="price">
						￥<span>{{item.price}}</span>
					</div>
				</van-swipe-item>
			</van-swipe>
			<div v-show="dateList.length === 0 " class="riitem riitem-c" @click="show=true">
				<div class="itemname">
					<div>请选择<br />入住日期 </div>
					<div>
						<van-icon name="arrow" />
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="rqlist scroll">
			<div class="tags">
				<div class="riitem riitem-active" @click="checkDate(item)" v-for="(item,index) in dateList" :key="index"
					style="margin-right: 5px;">
					<div class="itemname">
						<span>{{item.dd.week}}</span>
						<span>{{item.dd.dd}}</span>
					</div>
					<div class="price">
						￥<span>{{item.price}}</span>
					</div>
				</div>
				<div v-show="dateList.length === 0 " class="riitem riitem-c" @click="show=true">
					<div class="itemname">
						<div>请选择<br />入住日期 </div>
						<div>
							<van-icon name="arrow" />
						</div>
					</div>
				</div>
			</div>
		</div>
		 -->
		<van-calendar v-model="show" :type="dataType" :style="{ height: '75%' }" :default-date="selectDate"
			:formatter="formatter" :show-confirm="true" @confirm="onConfirm" />
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		name: 'leoCalendar',
		props: {
			title: {
				type: String,
				default: '选择日期'
			},
			titlermark: {
				type: String,
				default: '请选择使用日期'
			},
			bgColor: {
				type: String,
				default: "#fff8f9"
			},
			deData: {
				type: Object,
				default: {
					defaultDate: 0,
					Dates: []
				}
			},
			useDate: {
				type: String
			}
		},
		data() {
			return {
				show: false,
				prices: [],
				dateList: [],
				checkdate: '',
				sprice: '99',
				deDataList: this.deData,
				selectDate: null,
				dataType: 'multiple',
				selectDay: 1
			}
		},
		methods: {
			// 选中日期
			checkDate() {
				let that = this;
				let sedarry = that.dateList;
				let sd = []
				sedarry.forEach((item) => {
					let dd = new Date(item.dd.date)
					sd.push(dd);
				})
				this.selectDate = sd
			},
			onConfirm(date) {
				let that = this
				that.dateList = []
				date.forEach((itemdate) => {
					let dqdate = that.formatDate(itemdate);
					const yy = itemdate.getFullYear();
					const month = itemdate.getMonth() + 1;
					const day = itemdate.getDate();
					const zdate = yy + '-' + String(month < 10 ? '0' + month : month) + '-' + String(day < 10 ?
						'0' + day :
						day);
					let dd = that.deDataList.Dates;
					const price = that.getDatePrice(zdate);
					let item = {
						price: price,
						dd: that.getWeek(dqdate)
					};
					that.dateList.push(item);
				});
				that.selectDay = date.length
				// this.$emit('confirm', that.checkdate)
				//选择的时候是  存在 列表显示的 end
				that.show = false
			},
			// 获取星期
			getWeek(date) {
				let myDate = new Date(date);
				let newDate = new Date();
				let newyy = String(newDate.getFullYear());
				let newmm = newDate.getMonth() + 1;
				let newdd = String(newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate());
				let yy = String(myDate.getFullYear());
				let wk = myDate.getDay();
				let mm = myDate.getMonth() + 1;
				let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate());
				let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
				let tday = '';
				if (newyy == yy && newmm == mm) {
					if (newDate.getDate() - myDate.getDate() == 0) {
						tday = '今天'
					} else if (newDate.getDate() - myDate.getDate() == -1) {
						tday = '明天'
					}
				}
				let mmm = String(mm < 10 ? '0' + mm : mm);
				return {
					date: yy + '-' + mmm + '-' + dd,
					dd: mmm + '-' + dd,
					week: tday == '' ? weeks[wk] : tday
				};
			},
			getListDate(date) {
				let that = this;
				that.dateList = []
				let ddlist = []
				let ddate = that.GetDateStr(that.useDate, 0); //今天
				ddlist.push({
					price: that.getDatePrice(ddate),
					dd: that.getWeek(ddate)
				})
				that.dateList = ddlist;
			},
			GetDateStr(sdate, AddDayCount) {
				var dd = new Date();
				if (sdate != '') {
					dd = new Date(sdate);
				}
				dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1; //获取当前月份的日期
				var d = dd.getDate();
				m = String(m < 10 ? '0' + m : m);
				d = String(d < 10 ? '0' + d : d);
				return y + "-" + m + "-" + d;
			},
			getDatePrice(d) {
				let that = this;
				let dds = that.deDataList.Dates;
				if (dds.length == 0) {
					return that.deDataList.defaultPrice;
				}
				for (let i = 0; i < dds.length; i++) {
					if (dds[i].date == d) {
						return dds[i].price;
					}
				}
				return that.deDataList.defaultPrice;
			},
			formatDate(date) {
				return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
			},
			formatter(day) {
				let that = this
				const yy = day.date.getFullYear();
				const month = day.date.getMonth() + 1;
				const date = (day.date.getDate());
				const zdate = yy + '-' + String(month < 10 ? '0' + month : month) + '-' + String(date < 10 ? '0' + date :
					date);
				var price = that.getDatePrice(zdate);
				day.bottomInfo = `￥${price}`;
				let nn = that.GetDateStr(that.useDate, -1)
				if (that.compare(nn, day.date)) {
					day.type = 'disabled'
				}
				return day;
			},
			compare(d1, d2) {
				let ds1 = new Date(d1);
				let ds2 = new Date(d2);
				if (ds2 > ds1) {
					return false
				} else {
					return true
				}
			}
		},
		mounted() {
			Toast.loading({
				message: '请稍后...',
				loadingType: 'spinner',
				forbidClick: true,
				duration: 0, //展示时长(ms)，值为 0 时，toast 不会消失
				className: 'leoloading'
			});
			console.log(this.dateList.length)
			setTimeout(() => {
				// this.getListDate(null)
				// this.checkDate(); //默认选中第一天
				Toast.clear()
			}, 300);
		}
	}
</script>

<style lang="less" scoped="scoped">
	/deep/ .van-popup--bottom {
		margin-bottom: 0 !important;
	}

	.rqlist {
		display: flex;

		.riitem {
			border-radius: 8px;
			font-size: 14px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.price {
				color: #ff0000;
				font-size: 12px;

				span {
					font-size: 15px;
					font-weight: 600;
				}
			}
		}

		.riitem-active {
			background: linear-gradient(to right, #ffaa7f, #ffaa00);
		}

		.riitem-c {
			background-color: #FFFFFF;
			width: 85px;
			height: 60px;

			.itemname {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.riitems {
			.tips-top {
				position: absolute;
				top: -10px;
				left: 0;
				font-size: 10px;
				background-color: #ff5500;
				color: #FFFFFF;
				border-top-left-radius: 5px;
				border-bottom-right-radius: 5px;
				padding: 0 2px;
			}
		}

		.tags {
			display: flex;

			.riitem {
				width: 85px;
				height: 60px;
			}
		}
	}

	.scroll {
		overflow-y: hidden;
		overflow-x: auto;
	}
</style>
